import type { ItemType } from '../../shared/types'
import { drawItemGlyph } from './entities'

/** The real required tool, with an amber ! so the warning does not rely on colour. */
export function drawToolWarning(
  ctx: CanvasRenderingContext2D, tool: ItemType, x: number, y: number, size = 26,
): void {
  ctx.save()
  ctx.translate(x, y)
  ctx.globalAlpha = 1
  const half = size / 2
  ctx.fillStyle = 'rgba(34,25,12,.96)'
  ctx.strokeStyle = '#f4c566'
  ctx.lineWidth = size * .06
  ctx.beginPath(); ctx.roundRect(-half, -half, size, size, size * .24); ctx.fill(); ctx.stroke()
  drawItemGlyph(ctx, tool, size * .85)
  // A separate corner marker leaves the tool silhouette easy to recognize.
  const bx = half * .86, by = -half * .86, radius = size * .23
  ctx.fillStyle = '#f4c566'
  ctx.beginPath(); ctx.arc(bx, by, radius, 0, Math.PI * 2); ctx.fill()
  ctx.fillStyle = '#22190c'
  ctx.fillRect(bx - size * .035, by - size * .13, size * .07, size * .15)
  ctx.fillRect(bx - size * .035, by + size * .065, size * .07, size * .07)
  ctx.restore()
}
